export default "__VITE_ASSET__5696fbc4__"